// extracted by mini-css-extract-plugin
export default {"slider":"RangeSlider_slider__Qgr3d"};